import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Colors } from '../../layout/theme-next';

interface TabTitleProps {
  selected?: boolean
}

interface TabIconWrapperProps {
  selected?: boolean
}

export const TabsRoot = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  paddingTop: theme.spacing(2),
  cursor: 'pointer',
}));

export const TabItemCount = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<TabIconWrapperProps>(({ selected, theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  marginLeft: theme.spacing(0.625),
  color: selected ? Colors.primary : Colors.textGray,
}));

export const TabTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<TabTitleProps>(({ selected, theme }) => ({
  marginLeft: theme.spacing(1.25),
  fontSize: 16,
  fontWeight: selected ? 600 : 400,
  letterSpacing: 0.25,
  color: selected ? Colors.primary : Colors.textGray,
}));

export const TabIconWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<TabIconWrapperProps>(({ selected }) => ({
  '& path': {
    fill: selected ? Colors.textBlack : Colors.textGray,
  },
}));

export const TabsContainer = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  msOverflowStyle: 'scrollbar',
  scrollbarWidth: 'auto',

  '&::-webkit-scrollbar': {
    backgroundColor: 'transparent',
    width: 9,
    height: 9,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'transparent',
    borderRadius: '1ex',
  },
  '&:hover::-webkit-scrollbar-thumb': {
    backgroundColor: 'var(--light-gray)',
    borderRadius: '1ex',
  },

  [theme.breakpoints.down('sm')]: {
    overflowX: 'hidden',
  },
}));
